import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import classNames from 'classnames';

import Button from 'rebook/apps/base/components/Button';
import uaDetector from 'rebook/apps/utils/uaDetector';
import { APPS } from 'rebook/apps/base/components/apps/constants';

import styles from './style.scss';


const AppButton = ({ extraClassName, target, isAudio, showText }) => {
  let platform, url, icon, metrikaGoal;
  const userAgent = navigator && navigator.userAgent ? navigator.userAgent : null;
  const qs = queryString.stringify({
    pagetype: target,
  });
  // probably server side
  if (!userAgent) {
    return null;
  }

  if (uaDetector.isIos(userAgent)) {
    platform = APPS.ios.name;
    icon = APPS.ios.icon;
    url = `${APPS.ios.installUrl}?${qs}`;
    metrikaGoal = 'PushButtoniOS';
  }
  else if (uaDetector.isAndroid(userAgent)) {
    platform = APPS.android.name;
    icon = APPS.android.icon;
    url = `${APPS.android.installUrl}?${qs}`;
    metrikaGoal = 'PushButtonAndroid';
  }
  const text = isAudio ? 'Слушать в приложении' : 'Читать в приложении';

  return platform
    ? (
      <div className={extraClassName}>
        <Button url={url} theme="secondary" handleClick={(e)=>{
          e.preventDefault();
          yaMetrikaReachGoal(metrikaGoal);
          window.location.href=url;
        }}>
          <div className={styles.content}>
            <span className={styles.iconWithText}>{icon}</span>
            <span className={styles.text}>{text}</span>
          </div>
        </Button>
      </div>
    )
    : (
      <div className={classNames(styles.appList, extraClassName)}>
        {Object.keys(APPS).map((item) => (
          <Button
            key={APPS[item].id}
            url={`${APPS[item].installUrl}?${qs}`}
            theme="secondary"
            extraClassName={styles.appListItem}>
            {showText
              ? (
                <div className={styles.appNameText}>
                  <div className={styles.iconWithText}>
                    {APPS[item].icon}
                  </div>
                  <div className={styles.name}>
                    {APPS[item].name}
                  </div>
                </div>
              )
              : (
                <span className={styles.icon}>
                  {APPS[item].icon}
                </span>
              )
            }
          </Button>
        ))}
      </div>
    );
};

AppButton.propTypes = {
  extraClassName: PropTypes.string,
  target: PropTypes.string.isRequired,
  isAudio: PropTypes.bool,
  showText: PropTypes.bool,
};

AppButton.defaultProps = {
  extraClassName: '',
  isAudio: false,
  showText: false,
};

export default AppButton;
